import React, { Fragment } from "react";
import { Loading } from "./Loading";
import axios from "axios";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { createUser, logOutUser, loadStatus } from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";

import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { BASE_URL } from "../constant";
import Loader from "react-loader-spinner";
import SimpleReactValidator from "simple-react-validator";
import { NetworkError } from "./NetworkError";
import {endpoints, http} from "../configs/https";

// import FormData from 'form-data';

class Tabligh extends React.Component {
  constructor() {
    super();
    this.state = {
      media: 0,
      question: 0,
      lectures: 0,
      house: 0,
      literature: 0,
      tabligh: 0,
      letters: 0,
      book: 0,
      tab_sms: 0,
      n_baiat: 0,
      n_tabligh: 0,
      participants: 0,
      tabligh_date: "",
      duration: 0,
      classes: 0,
      attendance: 0,
      phone: "",
      modal: false,
      isSubmitting: false,
      button_text: "Submit",
      attachment: null,
      returned_phone: "",
      month: 0,
      returned_baiat: 0,
      returned_media: 0,
      returned_house: 0,
      submitted: false,
      loading: true,
      startDate: new Date(),
      networkError: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
  }
  componentDidMount() {
    document.title = "TABLIGH - MKAN REPORT";
    this.setupValidator();
  }

  setupValidator() {
    this.setState({
      loading: false
    });
    const { year, month } = this.props.monthYear;
    const {failed} = this.props.status;
    if (failed){
      this.props.loadStatus(month,year);
    }
    this.validator = new SimpleReactValidator();
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  handleDate(date) {
    this.setState({
      startDate: date
    });
  }
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  }
  onChangeFile(e) {
    this.setState({ attachment: e.target.files[0] });
  }
  handleSubmit(event) {
    const { month, year,monthName } = this.props.monthYear;
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
      return;
    }
    if (this.state.phone.length > 11) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      });

      Toast.fire({
        type: "warning",
        title: "Nazim's phone number should not be greater than 11 characters"
      });
      return;
    }

    Swal.fire({
      title:
        "Are you sure you want to submit your tabligh report for " +
        monthName +
        " " +
        year +
        "?",
      text:
        "You won't be able to revert this after submitting, kindly check all details are accurate.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Submit",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33"
    }).then(result => {
      if (result.value) {
        this.LoadingBar.continousStart();
        this.setState({
          isSubmitting: true
        });
        const formData = new FormData();
        if (this.state.attachment != null)
          formData.append("attachment", this.state.attachment);
        formData.append("media", this.state.media);
        formData.append("attendance", this.state.attendance);

        formData.append("book", this.state.book);
        formData.append("media", this.state.media);

        formData.append("public", this.state.lectures);
        formData.append("literature", this.state.literature);
        formData.append("tabligh", this.state.tabligh);

        formData.append("letters", this.state.letters);
        formData.append("question", this.state.question);

        formData.append("tab_sms", this.state.tab_sms);
        formData.append("n_baiat", this.state.n_baiat);
        formData.append("house", this.state.house);

        formData.append("n_tabligh", this.state.n_tabligh);
        formData.append("participants", this.state.participants);

        formData.append(
          "tabligh_date",
          moment(this.state.startDate).format("YYYY-MM-DD")
        );
        formData.append("classes", this.state.classes);
        formData.append("phone", this.state.phone);

        formData.append("n_tabligh", this.state.n_tabligh);
        formData.append("duration", this.state.duration);
        formData.append("month", month);
        formData.append("year", year);

        http.post(endpoints.TABLIGH,
                formData, {'Content-Type': 'multipart/form-data'}
            )
            .then(res => {
              this.setState({
                isSubmitting: false
              });

              if (res.status != 201) {
                const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                });

                Toast.fire({
                  type: "warning",
                  title: "There is an error in your submission, try again"
                });
                this.LoadingBar.complete();
              } else {
                const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                });

                Toast.fire({
                  type: "success",
                  title: "Tabligh report submitted successfully "
                });
                this.LoadingBar.complete();
                this.setState({
                  startDate: new Date(),
                  media: 0,
                  question: 0,
                  lectures: 0,
                  house: 0,
                  literature: 0,
                  tabligh: 0,
                  letters: 0,
                  book: 0,
                  tab_sms: 0,
                  n_baiat: 0,
                  n_tabligh: 0,
                  participants: 0,
                  tabligh_date: "",
                  duration: 0,
                  classes: 0,
                  attendance: 0,
                  phone: "",
                  attachment: null,

                  submitted_by: res.submitted_by,
                  dateof: res.date,

                  returned_phone: res.phone,
                  month: res.month,
                  // modal: true,
                  // returned_phone : res.response.data.phone,
                  returned_baiat: res.n_baiat,
                  returned_media: res.media,
                  returned_house: res.house
                });
                this.props.loadStatus(month,year);

                // $('.modal').modal('show');
              }
            })
            .catch(error => {
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
              let errorMessage =
                  (typeof error === "string" && error) ||
                  "An error occured, please try again in a moment.";

              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "error",
                title: errorMessage
              });
              // alert(JSON.stringify(error));
              console.log(errorMessage);
            });

        // fetch(BASE_URL + "tabligh/", {
        //   method: "POST",
        //   headers: {
        //     Authorization: `Bearer ${this.props.user.token}`
        //   },
        //   body: formData
        // })
        //   .then(res => {
        //     this.setState({
        //       isSubmitting: false
        //     });
        //
        //     if (res.status != 201) {
        //       const Toast = Swal.mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 3000
        //       });
        //
        //       Toast.fire({
        //         type: "warning",
        //         title: "There is an error in your submission, try again"
        //       });
        //       this.LoadingBar.complete();
        //     } else {
        //       const Toast = Swal.mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 3000
        //       });
        //
        //       Toast.fire({
        //         type: "success",
        //         title: "Tabligh report submitted successfully "
        //       });
        //       this.LoadingBar.complete();
        //       this.setState({
        //         startDate: new Date(),
        //         media: 0,
        //         question: 0,
        //         lectures: 0,
        //         house: 0,
        //         literature: 0,
        //         tabligh: 0,
        //         letters: 0,
        //         book: 0,
        //         tab_sms: 0,
        //         n_baiat: 0,
        //         n_tabligh: 0,
        //         participants: 0,
        //         tabligh_date: "",
        //         duration: 0,
        //         classes: 0,
        //         attendance: 0,
        //         phone: "",
        //         attachment: null,
        //
        //         submitted_by: res.submitted_by,
        //         dateof: res.date,
        //
        //         returned_phone: res.phone,
        //         month: res.month,
        //         // modal: true,
        //         // returned_phone : res.response.data.phone,
        //         returned_baiat: res.n_baiat,
        //         returned_media: res.media,
        //         returned_house: res.house
        //       });
        //       this.checkStatus();
        //
        //       // $('.modal').modal('show');
        //     }
        //   })
        //   .catch(error => {
        //     this.setState({
        //       isSubmitting: false
        //     });
        //     this.LoadingBar.complete();
        //     if (error.message === "Network Error") {
        //       const Toast = Swal.mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 3000
        //       });
        //
        //       Toast.fire({
        //         type: "warning",
        //         title:
        //           "Network error, try again. Possibly no internet connection "
        //       });
        //     } else {
        //       if (error.response.status === 401) {
        //         this.props.logOutUser();
        //         window.location.replace("/");
        //         this.setState({});
        //         const Toast = Swal.mixin({
        //           toast: true,
        //           position: "top-end",
        //           showConfirmButton: false,
        //           timer: 3000
        //         });
        //
        //         Toast.fire({
        //           type: "error",
        //           title: "You need to log in again "
        //         });
        //       } else {
        //         const Toast = Swal.mixin({
        //           toast: true,
        //           position: "top-end",
        //           showConfirmButton: false,
        //           timer: 3000
        //         });
        //
        //         Toast.fire({
        //           type: "error",
        //           title: "Something went wrong, try again."
        //         });
        //       }
        //     }
        //   });
      }
    });
  }
  render() {
    const { year, monthName } = this.props.monthYear;
    const {data, isFetching, failed} = this.props.status;
    const {isSubmitting} = this.state;
    return (
      <div>
        {this.state.networkError || failed ? (
          <NetworkError />
        ) : (
          <section className="content">
            {this.state.loading || isFetching ? (
              <div>
                <div className="spinner">
                  <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height="40"
                    width="40"
                  />
                </div>
              </div>
            ) : (
              <div>
                {!data.tabligh ? (
                  <div>
                    <LoadingBar onRef={ref => (this.LoadingBar = ref)} />

                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header card-header-primary">
                            <h4 className="card-title">
                              TABLIGH (FAITH PROPAGATION) -{" "}
                              {monthName}, {year}
                            </h4>
                            <p className="card-category">
                              Complete the form below
                            </p>
                          </div>
                          <div className="card-body">
                            <form onSubmit={this.handleSubmit}>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Media Distributed (Cassette, CD, DVD)
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="media"
                                      name="media"
                                      min="0"
                                      value={this.state.media}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  {this.validator.message(
                                    "media",
                                    this.state.media,
                                    "required"
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Question and Answer Sessions{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="question"
                                      min="0"
                                      name="question"
                                      value={this.state.question}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  {this.validator.message(
                                    "question and answer",
                                    this.state.question,
                                    "required"
                                  )}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      House to house preaching
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="house"
                                      name="house"
                                      min="0"
                                      value={this.state.house}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                  {this.validator.message(
                                    "house preaching",
                                    this.state.house,
                                    "required"
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Public Lectures in the month
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="lectures"
                                      name="lectures"
                                      min="0"
                                      value={this.state.lectures}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                  {this.validator.message(
                                    "lectures",
                                    this.state.lectures,
                                    "required"
                                  )}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      Literature Books Distributed
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="literature"
                                      name="literature"
                                      min="0"
                                      value={this.state.literature}
                                      onChange={this.handleChange}
                                      min="0"
                                    />
                                  </div>
                                  {this.validator.message(
                                    "literature",
                                    this.state.literature,
                                    "required"
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Tabligh Meetings
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="tabligh"
                                      name="tabligh"
                                      min="0"
                                      value={this.state.tabligh}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  {this.validator.message(
                                    "tabligh",
                                    this.state.tabligh,
                                    "required"
                                  )}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      Letters on Tabligh in the month
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="letters"
                                      name="letters"
                                      value={this.state.letters}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Book Stall
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="book"
                                      name="book"
                                      value={this.state.book}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      Tabligh SMS/Emails
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="tab_sms"
                                      name="tab_sms"
                                      value={this.state.tab_sms}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Number of Bai'ats
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="n_baiat"
                                      name="n_baiat"
                                      value={this.state.n_baiat}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      No of Tabligh programmes organized in the
                                      month
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="n_tabligh"
                                      name="n_tabligh"
                                      value={this.state.n_tabligh}
                                      onChange={this.handleChange}
                                      min="0"
                                      required
                                    />
                                  </div>
                                  {this.validator.message(
                                    "tabligh",
                                    this.state.phone,
                                    "required"
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No participating Khuddam
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="participants"
                                      name="participants"
                                      value={this.state.participants}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      Duration
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="duration"
                                      name="duration"
                                      value={this.state.duration}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      How many classes were conducted for the
                                      tabligh team this month?
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="classes"
                                      name="classes"
                                      value={this.state.classes}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Date
                                    </label>

                                    <DatePicker
                                      selected={this.state.startDate}
                                      dateFormat="yyyy-MM-dd"
                                      onChange={this.handleDate}
                                    />
                                  </div>
                                </div>

                                {/* <div class="col-md-12">
                        <div class="form-group">
                         
                          <div class="form-group">
                            <label class="bmd-label-floating"> Dates of Classes</label>
                            <textarea 
                            class="form-control" 
                            id="date" 
                            
                            name="date"
                            onChange ={this.handleChange}
                            rows="5"></textarea>
                          </div>
                        </div>
                      </div> */}
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      {" "}
                                      Attendance
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="attendance"
                                      name="attendance"
                                      value={this.state.attendance}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                  {this.validator.message(
                                    "aattendance",
                                    this.state.attendance,
                                    "required"
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Nazim Tabligh's Phone number{" "}
                                    </label>

                                    <input
                                      type="tel"
                                      className="form-control"
                                      id="phone"
                                      name="phone"
                                      value={this.state.phone}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "nazim tabligh's phone number",
                                      this.state.phone,
                                      "required|min:5|max:11"
                                    )}
                                  </span>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-4 col-sm-4">
                                  <h4 className="title">
                                    Attach copies of biat forms of new convert
                                  </h4>

                                  <input
                                    type="file"
                                    onChange={this.onChangeFile}
                                  />
                                </div>
                              </div>

                              {isSubmitting ? <Loading /> : ""}

                              <button
                                type="submit"
                                className="btn btn-success pull-right"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? "Loading..." : "Submit"}
                              </button>
                              <div className="clearfix" />
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {/* <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button> */}
                      <Modal
                        isOpen={this.state.modal}
                        toggle={this.toggle}
                        className={this.props.className}
                      >
                        <ModalHeader toggle={this.toggle}>
                          Report submission status
                        </ModalHeader>
                        <ModalBody>
                          <p>
                            Submitted By : {this.state.submitted_by}
                            <br />
                            Month :{" "}
                            {moment()
                              .month(this.state.month - 1)
                              .format("MMMM")}
                            <br />
                            Date of Submission :{" "}
                            <Moment date={this.state.dateof} />
                            <br />
                            Media: {this.state.returned_media}
                            <br />
                            Baiat : {this.state.returned_baiat}
                            <br />
                            House Preaching : {this.state.returned_house}
                            <br />
                            Nazim Tabligh's Phone : {this.state.returned_phone}
                          </p>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="primary" onClick={this.toggle}>
                            Close
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <h2>
                      You already submitted Tabligh report for{" "}
                      <b>
                        {monthName}, {year}
                      </b>
                    </h2>
                  </div>
                )}
              </div>
            )}
          </section>
        )}
      </div>
    );
  }
}

Tabligh.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear,
  status: state.status,
});

export default connect(mapStateToProps, { createUser, logOutUser, loadStatus })(Tabligh);
